<template>
    <div class="container">
        <div class="row justify-content-center align-items-center mt-4 mb-4" style="min-height: calc(100vh - 3rem)">
            <div class="col-12 col-sm-6">


                <div class="mb-3 text-center mt-3 mt-sm-0">
                    <img class="img-stockradars img-fluid"
                         src="../assets/images/stockradars.png">
                </div>


                <div class="text-center mb-3">
                    <div class="title">
                        เปิดบัญชีออนไลน์ ง่าย!
                    </div>

                    <div class="sub-title">
                        เพียง 3 ขั้นตอน
                    </div>
                </div>


                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="row no-gutters">
                            <div class="col-auto text-center">
                                <div class="list">
                                    1.
                                </div>
                            </div>
                            <div class="col"> ลงทะเบียนผ่าน StockRadars</div>
                        </div>
                        <div class="row no-gutters">
                            <div class="col-auto text-center">
                                <div class="list">
                                    2.
                                </div>
                            </div>
                            <div class="col"> กรอกข้อมูลกับ Krungsri Securities</div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-auto text-center">
                                <div class="list">
                                    3.
                                </div>
                            </div>
                            <div class="col"> รอการติดต่อกลับจากเจ้าหน้าที่</div>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="text-center mb-3 font-weight-bold" style="font-size: 18px">
                    กรุณาเตรียมเอกสารประกอบการสมัครดังนี้
                </div>
                <div class="row justify-content-center">
                    <div class="col-auto text-center mb-3 mb-sm-0">
                        <img class="img-document"
                             src="../assets/images/id.png">
                        <div>บัตรประชาชน</div>
                    </div>
                    <div class="col-auto text-center mb-3  mb-sm-0">
                        <img class="img-document"
                             src="../assets/images/bank.png">
                        <div>หน้าแรกสมุดบัญชีธนาคาร</div>
                    </div>
                </div>


                <div class="d-none d-sm-block">
                    <hr>
                    <div class="row justify-content-center mb-3 ">
                        <div class="col-auto mb-3 mb-sm-0 ">
                            <div class="font-weight-bold"> สอบถามข้อมูลเพิ่มเติม</div>
                            <div class="small"> Tel. 092-249-4999 (จันทร์-ศุกร์ 10.00 - 19.00 น.)</div>
                            <div class="small"> Facebook page : <a class="text-kss font-weight-bold"
                                                                   href="https://m.me/stockradars"
                                                                   target="_blank">StockRadars </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div class="col-12 col-sm-6 bg-kss">

                <div class="row justify-content-center mt-5 mb-5">
                    <div class="col-12 col-sm-10">

                        <div class="text-center mb-3">
                            <img class="img-broker img-fluid"
                                 src="../assets/images/kss-icon-hd.png">
                        </div>


                        <div class="text-center mb-4">
                            <div class="text-white" style="font-size: 18px">
                                ลงทะเบียนซื้อขายหลักทรัพย์ผ่าน StockRadars
                            </div>

                            <div class="text-description small">
                                โดย บริษัทหลักทรัพย์ กรุงศรี จำกัด (มหาชน)
                            </div>
                        </div>


                        <div class="form-group">
                            <div class="input-group">
                                <input type="text" v-model="form.fullname" class="form-control"
                                       placeholder="ชื่อ - สกุล ภาษาไทย">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                         <img class="input-icon"
                                              src="../assets/images/person.png">
                                    </span>
                                </div>
                            </div>

                            <error-message class="mt-1" :msg="errorMessage.fullname"></error-message>
                        </div>

                        <div class="form-group">
                            <div class="input-group">
                                <input v-model="form.mobile" class="form-control"
                                       pattern="[0-9]*" inputmode="numeric"
                                       placeholder="เบอร์โทรศัพท์">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                         <img class="input-icon"
                                              src="../assets/images/phone.png">
                                    </span>
                                </div>
                            </div>

                            <error-message class="mt-1" :msg="errorMessage.mobile"></error-message>
                        </div>

                        <div class="mb-4">
                            <div class="input-group">
                                <input type="text" v-model="form.email" class="form-control" placeholder="อีเมล">
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                         <img class="input-icon"
                                              src="../assets/images/email.png">
                                    </span>
                                </div>
                            </div>

                            <error-message class="mt-1" :msg="errorMessage.email"></error-message>
                        </div>


                        <button class="btn btn-kss w-100 font-weight-bold" @click="register">
                            เปิดบัญชีซื้อขายหลักทรัพย์
                        </button>


                    </div>
                </div>


            </div>

            <div class="col-12 d-block d-sm-none">
                <div class="row justify-content-center mt-4">
                    <div class="col-auto ">
                        <div class="font-weight-bold"> สอบถามข้อมูลเพิ่มเติม</div>
                        <div class="small"> Tel. 092-249-4999 (จันทร์-ศุกร์ 10.00 - 19.00 น.)</div>
                        <div class="small"> Facebook page : <a class="text-kss font-weight-bold"
                                                               href="https://m.me/stockradars"
                                                               target="_blank">StockRadars </a>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import validate from 'validate.js';
    import ErrorMessage from "../components/ErrorMessage";
    import {userService} from "../services/userService";
    import Swal from 'sweetalert2'

    export default {
        name: 'Home',
        components: {ErrorMessage},
        created() {
            this.form.refCode = this.$route.query.ref || null;
            this.form.line_mid = this.$route.query.mid || null;
        },
        data() {
            return {
                form: {
                    fullname: '',
                    mobile: '',
                    line_mid: '',
                    email: '',
                    brokerName: 'Krungsri',
                    refCode: 'STOCKRADARS'
                },

                errorMessage: {}
            }
        },
        methods: {
            async register() {
                let errorMessage = this.validateForm(this.form);

                if (errorMessage) {
                    return this.errorMessage = errorMessage;
                } else {
                    this.errorMessage = {};
                }

                if (this.isLoading) return;
                this.isLoading = true;

                let result = await userService.register(this.form);

                if (result.status === 'yes') {
                    Swal.fire(
                        {
                            html: `<div>


                                <div class="small mb-3">กรุณาดำเนินการเปิดบัญชีซื้อขายหลักทรัพย์ ผ่านระบบออนไลน์ให้สำเร็จ ตามลิงค์นี้ 👉🏻 <a href="https://ccm.krungsrisecurities.com/requestonline/OPENACCOUNT/?sectionurl=OPWELCOME&lang=TH&transchannel=sradar&openExternalBrowser=1&utm_source=STOCKRADAR&utm_medium=Organic&utm_campaign=KSSeOpen" target="_blank">
                                https://ccm.krungsrisecurities.com/requestonline</a> </div>

                                <div class="small">☎️ หากมีข้อสงสัย สามารถติดต่อสอบถามบริษัทหลักทรัพย์ กรุงศรี จำกัด (มหาชน) ได้ที่เบอร์ 026597000 </div>

                            `,
                            icon: 'success',
                            customClass: {
                                confirmButton: 'btn-primary'
                            },
                            allowOutsideClick: false,
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                        window.open('https://ccm.krungsrisecurities.com/requestonline/OPENACCOUNT/?sectionurl=OPWELCOME&lang=TH&transchannel=sradar&openExternalBrowser=1&utm_source=STOCKRADAR&utm_medium=Organic&utm_campaign=KSSeOpen', '_blank')
                    });

                    this.form = {};
                } else {
                    Swal.fire(
                        {
                            text: result.message,
                            icon: 'error',
                            customClass: {
                                confirmButton: 'btn-primary'
                            }
                        });
                }


                this.isLoading = false;

            },
            validateForm(data) {
                let validateRule = null;
                let errMessageList = null;

                validateRule = {
                    fullname: {
                        presence: {
                            allowEmpty: false,
                            message: "^โปรดระบุ ชื่อ - สกุล"
                        },
                        // format: {
                        //     pattern: "^[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ ]+$",
                        //     message: function (value) {
                        //         return validate.format("^ กรุณากรอก ชื่อ - สกุล เป็นภาษาไทย", {
                        //             num: value
                        //         });
                        //     }
                        // },
                    },
                    mobile: {
                        presence: {
                            allowEmpty: false,
                            message: "^โปรดระบุ เบอร์โทรศัพท์"
                        },
                        numericality: {
                            onlyInteger: true,
                            message: "^เบอร์โทรศัพท์ ไม่ถูกต้อง"
                        }
                    },
                    email: {
                        presence: {
                            allowEmpty: false,
                            message: "^โปรดระบุ อีเมล"
                        },
                        email: {
                            message: "^อีเมล ไม่ถูกต้อง"
                        },
                    }
                };

                errMessageList = validate(
                    {
                        fullname: data.fullname,
                        mobile: data.mobile,
                        email: data.email
                    }, validateRule);

                if (errMessageList) {
                    const error = {};
                    for (const [key, value] of Object.entries(errMessageList)) {
                        error[key] = value[0];
                    }
                    return error;
                } else {
                    return false;
                }

            },
        }
    }
</script>

<style lang="scss" scoped>

    @import "../assets/css/colors";

    input:focus {
        outline: none !important;
    }


    input, input:focus, input:hover, .input-group-text {
        background-color: $white;
        color: $brown;
        box-shadow: none;
        outline: none;
        border: 1px solid $white;
        height: 50px;
    }

    .input-icon {
        max-height: 20px;
    }

    .img-document {
        max-height: 70px;
        margin-bottom: 15px;
    }

    .btn-kss {
        color: $brown;
        height: 50px;
        background: #FFD400;
    }

    .img-stockradars {
        max-height: 50px;
    }

    .img-broker {
        max-height: 220px;
    }

    .text-description {
        color: #FFD400;
    }

    .bg-kss {
        background: $brown;
        border-radius: 8px;
    }

    .text-kss {
        color: $brown;
    }

    .list {
        color: $white;
        background: $brown;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 8px;
        margin-bottom: 8px;
    }
</style>

